import { TextInput, type TextInputProps } from '@mantine/core'
import { forwardRef } from 'react'

function toDisplay(e164?: string): string {
  if (!e164) return ''
  if (e164.startsWith('+1')) {
    const d = e164.slice(2, 12)
    if (d.length > 6) return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`
    if (d.length > 3) return `(${d.slice(0, 3)}) ${d.slice(3)}`
    if (d.length > 0) return `(${d}`
    return ''
  }
  return e164
}

function toE164(raw: string): string {
  if (raw.trim().startsWith('+')) {
    const digits = raw.replace(/\D/g, '')
    return `+${digits.slice(0, 15)}`
  }
  let digits = raw.replace(/\D/g, '')
  if (digits.length === 11 && digits.startsWith('1')) digits = digits.slice(1)
  digits = digits.slice(0, 10)
  return digits ? `+1${digits}` : ''
}

export type USPhoneInputProps = Omit<TextInputProps, 'value' | 'onChange'> & {
  value?: string
  onChange?: (value: string) => void
}

export const USPhoneInput = forwardRef<HTMLInputElement, USPhoneInputProps>(
  ({ value, onChange, ...props }, ref) => (
    <TextInput
      ref={ref}
      type="tel"
      value={toDisplay(value)}
      onChange={(event) => onChange?.(toE164(event.currentTarget.value))}
      {...props}
    />
  ),
)
USPhoneInput.displayName = 'USPhoneInput'
